import { useEffect } from "react";

export function usePrompt(message, when = true) {
  useEffect(() => {
    if (!when) return;

    const handler = (e) => {
      e.preventDefault();
      e.returnValue = message;
    };

    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [message, when]);
}
